import { BACKGROUND_IMAGE_SELECTED } from '../../action-types/ui/backgroundImageSelected';

export const backgroundImageSelected = flag => ({
  type: BACKGROUND_IMAGE_SELECTED,
  flag,
});




// WEBPACK FOOTER //
// ./src/redux/actions/ui/backgroundImageSelected.js